<template>
  <div class="report-page">
    <div class="card">
      <div class="card-body">
        <b-alert :show="!!errorMessage" variant="danger">{{ errorMessage }}</b-alert>

        <div class="toolbar d-flex align-items-center flex-wrap mb-2">
          <span class="text-muted small">จำนวนคนไข้ปัจจุบันในแต่ละระดับ แยกตามสาขา</span>
          <div class="spacer flex-grow-1"></div>
          <b-button size="sm" variant="outline-secondary" class="mr-2" :disabled="isLoading" @click="load">
            <i class="fas fa-sync-alt mr-1" :class="{ 'fa-spin': isLoading }" aria-hidden="true"></i>โหลดข้อมูลใหม่
          </b-button>
          <b-dropdown text="ส่งออก" size="sm" variant="outline-success" right :disabled="!pivot.branchRows.length">
            <b-dropdown-item @click="exportExcel">
              <i class="fas fa-file-excel mr-2"></i>Excel
            </b-dropdown-item>
            <b-dropdown-item @click="exportPdf">
              <i class="fas fa-file-pdf mr-2"></i>PDF
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <div v-if="isLoading && !loaded" class="text-center text-muted py-4">
          <b-spinner small class="mr-2"></b-spinner>กำลังโหลดรายงาน...
        </div>

        <div v-else class="table-responsive">
          <table id="tierDistributionTable" class="table table-sm table-bordered mb-0">
            <thead class="thead-light">
              <tr>
                <th>สาขา</th>
                <th v-for="col in pivot.tierColumns" :key="col.key" class="text-right">{{ col.label }}</th>
                <th class="text-right">รวม</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!pivot.branchRows.length">
                <td :colspan="pivot.tierColumns.length + 2" class="text-center text-muted py-3">
                  ไม่มีข้อมูลให้แสดง
                </td>
              </tr>
              <tr v-for="row in pivot.branchRows" v-else :key="row.branchId">
                <td>{{ row.branchName }}</td>
                <td v-for="col in pivot.tierColumns" :key="col.key" class="text-right">{{ row[col.key] }}</td>
                <td class="text-right font-weight-bold">{{ row._total }}</td>
              </tr>
            </tbody>
            <tfoot v-if="pivot.branchRows.length">
              <tr class="table-secondary text-bold">
                <td>{{ pivot.totalsRow.branchName }}</td>
                <td v-for="col in pivot.tierColumns" :key="col.key" class="text-right">
                  {{ pivot.totalsRow[col.key] }}
                </td>
                <td class="text-right">{{ pivot.totalsRow._total }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { tierErrorMessage } from "@/utils/tierErrors";
import { exportTableToExcel, exportReportToPdf } from "@/utils/reportExport";
import { buildDistributionPivot } from "@/utils/tierReportDisplay";

export default {
  name: "TierDistributionReport",
  data() {
    return {
      isLoading: false,
      loaded: false,
      errorMessage: "",
      report: [],
      reportTitle: "รายงานจำนวนคนไข้ตามระดับ",
      reportNameEn: "TierDistribution",
    };
  },
  computed: {
    ...mapGetters({
      clinicInfo: "moduleBranch/getClinicInfo",
    }),
    clinicUrl() {
      return this.$route.params.clinicUrl;
    },
    // See src/utils/tierReportDisplay.js — this turns the flat
    // {tierId, tierName, branchId, branchName, patientCount} rows the
    // backend returns into the branch x tier matrix this report is meant
    // to be ("headcount per tier per branch").
    pivot() {
      return buildDistributionPivot(this.report);
    },
  },
  methods: {
    ...mapActions("moduleTier", ["getTierReport"]),

    async load() {
      if (!this.clinicUrl) return;
      this.isLoading = true;
      this.errorMessage = "";
      try {
        this.report = await this.getTierReport({ clinicUrl: this.clinicUrl, type: "distribution" });
        this.loaded = true;
      } catch (error) {
        this.errorMessage = tierErrorMessage(error) || "โหลดรายงานไม่สำเร็จ";
      } finally {
        this.isLoading = false;
      }
    },

    exportOptions() {
      return {
        tableId: "tierDistributionTable",
        reportTitle: this.reportTitle,
        reportNameEn: this.reportNameEn,
        clinicName: this.clinicInfo && this.clinicInfo.name,
      };
    },
    exportExcel() {
      exportTableToExcel(this.exportOptions());
    },
    exportPdf() {
      exportReportToPdf(this.exportOptions());
    },
  },
  created() {
    this.load();
  },
};
</script>

<style scoped>
.spacer {
  min-width: 8px;
}
</style>
